import React, { useState } from "react";

const GenderLeadershipEntryRequirements = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Direct Route",
      content: `Applicants who do not meet the ESBD Route criteria can apply through the Direct Route.

- Must have completed senior secondary school education.
- Must hold an undergraduate qualification from an accredited institution.

- Programme Progression: Applicants via this route will undertake all modules included in the Postgraduate Diploma
in Senior Executive Women Leader Programme & will be required to pay the fees for
the Postgraduate Diploma.`,
    },
    {
      id: 2,
      title: "ESBD Route",
      content: `Applicants must have successfully completed the Postgraduate Diploma in Senior
Executive Women Leader Course: The Certified Women Leadership & Gender
Changemaker Programme.

- Programme Progression: If you qualify through this route, you will proceed to undertake six additional modules,
followed by a Dissertation.

- Assessment by the Admissions Panel:
If you do not meet the criteria automatically, our Admissions Panel will assess your application individually. The Panel will 
evaluate qualifications not specified above, incomplete qualifications (e.g. diplomas / secondary school education), & significant 
relevant work experience. If your current qualifications & experience are insufficient, we will suggest which 
qualifications you could pursue to attain eligibility in the future.

- Alternative Entry Routes:
Alternative entry routes are available for applicants who do not possess the standard entry qualifications but
have certain appropriate skills and/or work/professional experience.

- The Admissions Committee:
The Admissions Committee may consider applications from suitably qualified students currently attending other
universities. Applicants who have achieved a lower-level award, or applicants seeking admission based
on Recognition of Prior Learning (RPL), are welcome to apply.
`,
    },
    {
      id: 3,
      title: "Proof of Proficiency in the English Language",
      content: `The following qualifications meet our English language requirement:
      
- Native English speakers
- TOEFL - Minimum score: 213 (computer based), 79/93 (internet based), or 550 (paper based);
- IELTS - Minimum score: 6.5
- Cambridge ESOL, Certificate in Advanced English (CAE) - Minimum score: C1
- English as the language of instruction during previous studies in the formal educational system
- Any Equivalent English language proficiency you would want us to consider`,
    },
    {
      id: 4,
      title: "Identity Check",
      content: `Applicants must submit a valid ID during application & verify their identity via a live Zoom session
at the start of the course.`,
    },
  ];

  return (
    <div className="md:scroll-mt-44 scroll-mt-16 my-10" id="entry-requirements">
      <div className="bg-sddarkgray py-5">
        <div className="max-w-6xl mx-auto px-10 space-y-5">
          <h2 className="text-xl font-bold mb-4 text-gray-50">
            Entry Requirements
          </h2>
          <div className="bg-gray-50 h-1 w-14 "></div>
          <div className="space-y-1">
            {sections.map((section) => (
              <div key={section.id} className="border-y border-black">
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-2 px-3 bg-blue-50 hover:bg-blue-100 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium">{section.title}</span>
                    <span>{activeSection === section.id ? "▲" : "▼"}</span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-3 py-2 bg-sdbodywhite border-t border-gray-300">
                    <p className="text-gray-700 whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderLeadershipEntryRequirements;
